module.exports = __webpack_public_path__ + "static/img/4.3013d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail1/4.png
// module id = y3pD
// module chunks = 19